import Deal_1 from "../assets/Rectangle 1.png";
import Deal_2 from "../assets/Rectangle 2.png";
import Deal_3 from "../assets/Rectangle 3.png";
import Deal_4 from "../assets/Rectangle 4.png";
import Deal_5 from "../assets/alaska_hubbard.jpg";
import Deal_6 from "../assets/meddatrian.png";
import Deal_7 from "../assets/western.jpg";
import Deal_8 from "../assets/Oasis.jpg";
import Deal_9 from "../assets/europe2.jpg";
import Deal_10 from "../assets/antarctica.png";
import Deal_11 from "../assets/CEL_Galapagos_Landscape_17.jpg";
import Deal_12 from "../assets/Equinox.jpg";
import Deal_13 from "../assets/Silhouette.jpg";
import Deal_14 from "../assets/EUROPE.jpg";
import Deal_15 from "../assets/ARCTIC.jpg";
import Deal_16 from "../assets/silver moon.jpg";
import Deal_17 from "../assets/silver nova.jpg";
import Deal_18 from "../assets/silver muse.jpg";
import Deal_19 from "../assets/CEL_island.jpg";
import Deal_20 from "../assets/CEL_EG_Alaska.jpg";
import Deal_21 from "../assets/edge.jpg";
import Deal_22 from "../assets/millinium.jpg";
import Deal_23 from "../assets/apex.jpg";
import Deal_24 from "../assets/Beyond.jpg";
import Deal_25 from "../assets/Ascent.jpg";
import Deal_26 from "../assets/flora.jpg";
import Deal_27 from "../assets/Xcel.jpg";
import Deal_28 from "../assets/reflection.jpg";
import Deal_29 from "../assets/Solstice.jpg";
import Deal_30 from "../assets/Eclipse.jpg";
import Deal_31 from "../assets/infinity-ship-2-2560x1440.jpg";
import Deal_32 from "../assets/Constellation.jpg";
import Deal_33 from "../assets/Summit.jpg";
import Deal_34 from "../assets/CEL_ML_Catalina Island (1).jpg";
import Deal_35 from "../assets/RCI_PDC_20240203_ASP_PBoer_HideawayBeach_DJI_0020_RT.jpg";
import Deal_36 from "../assets/RCI_RD_HubbardGlacier053F_Ret.jpg";
import Deal_37 from "../assets/italy_europe.jpg";
import Deal_38 from "../assets/RCI_GoH_Dan_Labadee_Cave_Rock_Dive_048_V2_RET_CMYK.jpg";
import Deal_39 from "../assets/allure.jpg";
import Deal_40 from "../assets/Quantum.jpg";
import Deal_41 from "../assets/Adventure.jpg";
import Deal_42 from "../assets/Anthem.jpg";
import Deal_43 from "../assets/brilliance.jpg";
import Deal_44 from "../assets/Enchant.jpg";
import Deal_45 from "../assets/Explorer.jpg";
import Deal_46 from "../assets/freedom.jpg";
import Deal_47 from "../assets/Grandeur.jpg";
import Deal_48 from "../assets/harmony.jpg";
import Deal_49 from "../assets/Icon.jpg";
import Deal_50 from "../assets/independence.jpg";
import Deal_51 from "../assets/jewel.jpg";
import Deal_52 from "../assets/legend.jpg";
import Deal_53 from "../assets/liberty.jpg";
import Deal_54 from "../assets/mariner.jpeg";
import Deal_55 from "../assets/navigator.jpg";
import Deal_56 from "../assets/Odyssey.jpg";
import Deal_57 from "../assets/Ovation.jpg";
import Deal_58 from "../assets/Radiance.jpg";
import Deal_59 from "../assets/rhapsody.jpg";
import Deal_60 from "../assets/serenade.jpg";
import Deal_61 from "../assets/spectrum-of-the-seas.avif";
import Deal_62 from "../assets/star.jpg";
import Deal_63 from "../assets/Symphony.jpg";
import Deal_64 from "../assets/utopia.jpg";
import Deal_80 from "../assets/vision.jpg";
import Deal_81 from "../assets/Voyager.jpg";

import Deal_65 from "../assets/Silver muse.avif";
import Deal_66 from "../assets/Silver Dawn.avif";
import Deal_67 from "../assets/Silver Moon.avif";
import Deal_68 from "../assets/Silver Nova.avif";
import Deal_69 from "../assets/Silver Ray.avif";
import Deal_70 from "../assets/Silver Shadow.avif";
import Deal_71 from "../assets/Silver Spirit.avif";
import Deal_72 from "../assets/Silver Whisper.avif";
import Deal_73 from "../assets/Silver Cloud.avif";
import Deal_74 from "../assets/Silver Endeavour.avif";
import Deal_75 from "../assets/Silver Origin.avif";
import Deal_76 from "../assets/Silver Wind.avif";
import Deal_77 from "../assets/CEL_EG_Alaska.jpg";
import Deal_78 from "../assets/hongkong.jpg";
import Deal_79 from "../assets/SSC_Galapagos_0M6A3191.jpg";
import Deal_82 from "../assets/bahama.jpg";
import Deal_83 from "../assets/carribean.jpg";
import Deal_84 from "../assets/autralia and new zealand.jpg";
import Deal_85 from "../assets/asia.jpg";


const Dealdata = [
    {
        img:Deal_1,
        Dealname:"Explore Europe"
    },
    {
        img:Deal_2,
        Dealname:"Last Frontier Alaska"
    },
    {
        img:Deal_3,
        Dealname:"Bahamas & Caribbean"
    },
    {
        img:Deal_4,
        Dealname:"Asia"
    },
    {
        img:Deal_5,
        Dealname:"Alaska Hubbard Glacier Cruise",
        link: 'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&destinations=1&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_6,
        Dealname:"Western Mediterranean"
    },
    {
        img:Deal_7,
        Dealname:"Wonder of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-wonder-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=14719&showPromoCodes=true'
    },
    {
        img:Deal_8,
        Dealname:"Oasis of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-oasis-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=1191&showPromoCodes=true'
    },
    {
        img:Deal_9,
        Dealname:"Europe Cruise",
        link :'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&destinations=57,38,16,15,39,40,41&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_10,
        Dealname:"Antarctica Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8115&destinationtype=All&Destinations=65&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_11,
        Dealname:"Galapagos Outer Loop Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&destinations=60&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_12,
        Dealname:"Celebrity Equinox",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-equinox?siid=1035987&lang=1&CruiseLine=2&ship=1176&showPromoCodes=true'
    },
    {
        img:Deal_13,
        Dealname:"Celebrity Silhouette",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-silhouette?siid=1035987&lang=1&CruiseLine=2&ship=13281&showPromoCodes=true'
    },
    {
        img:Deal_14,
        Dealname:"Europe Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8115&destinationtype=All&Destinations=121,57,38,15,75,39,188,41&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_15,
        Dealname:"Arctic and Greeland Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8115&destinationtype=All&Destinations=61,67&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_16,
        Dealname:"Silver Moon"
    },
    {
        img:Deal_17,
        Dealname:"Silver Nova"
    },
    {
        img:Deal_18,
        Dealname:"Silver Muse"
    },
    {
        img:Deal_19,
        Dealname:"Iceland Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&DeparturePorts=REK&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_20,
        Dealname:"Alaska Southbond Cruise"
    },
    {
        img:Deal_21,
        Dealname:"Celebrity Edge",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-edge?siid=1035987&lang=1&CruiseLine=2&ship=13858&showPromoCodes=true'
    },
    {
        img:Deal_22,
        Dealname:"Celebrity Millenium",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-millennium?siid=1035987&lang=1&CruiseLine=2&ship=26&showPromoCodes=true'
    },
    {
        img:Deal_23,
        Dealname:"Celebrity Apex",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-apex?siid=1035987&lang=1&CruiseLine=2&ship=14393&showPromoCodes=true'
    },
    {
        img:Deal_24,
        Dealname:"Celebrity Beyond",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-beyond?siid=1035987&lang=1&CruiseLine=2&ship=14948&showPromoCodes=true'
    },
    {
        img:Deal_25,
        Dealname:"Celebrity Ascent",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-ascent?siid=1035987&lang=1&CruiseLine=2&ship=15141&showPromoCodes=true'
    },
    {
        img:Deal_26,
        Dealname:"Celebrity Flora",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-flora?siid=1035987&lang=1&CruiseLine=2&ship=14014&showPromoCodes=true'
    },
    {
        img:Deal_27,
        Dealname:"Celebrity Xcel",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-xcel?siid=1035987&lang=1&CruiseLine=2&ship=15336&showPromoCodes=true'
    },
    {
        img:Deal_28,
        Dealname:"Celebrity Reflection",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-reflection?siid=1035987&lang=1&CruiseLine=2&ship=13486&showPromoCodes=true'
    },
    {
        img:Deal_29,
        Dealname:"Celebrity Solstice",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-solstice?siid=1035987&lang=1&CruiseLine=2&ship=1117&showPromoCodes=true'
    },
    {
        img:Deal_30,
        Dealname:"Celebrity Eclipse",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-eclipse?siid=1035987&lang=1&CruiseLine=2&ship=13232&showPromoCodes=true'
    },
    {
        img:Deal_31,
        Dealname:"Celebrity Infinity",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-infinity?siid=1035987&lang=1&CruiseLine=2&ship=24&showPromoCodes=true'
    },
    {
        img:Deal_32,
        Dealname:"Celebrity Constellation",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-constellation?siid=1035987&lang=1&CruiseLine=2&ship=21&showPromoCodes=true'
    },
    {
        img:Deal_33,
        Dealname:"Celebrity Summit",
        link:'https://booking.tirun.com/swift/cruise/ship/celebrity-cruises-celebrity-summit?siid=1035987&lang=1&CruiseLine=2&ship=27&showPromoCodes=true'
    },
    {
        img:Deal_34,
        Dealname:"Island Cruise"
    },
    {
        img:Deal_35,
        Dealname:"Bahamas and Perfect Day Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&destinations=7&sortColumn=cruiselinePriority&sortOrder=asc'
    },
    {
        img:Deal_36,
        Dealname:"Alaska Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&destinations=1&sortColumn=cruiselinePriority&sortOrder=asc'
    },
    {
        img:Deal_37,
        Dealname:"Europe",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&destinations=16,15,75,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc'
    },
    {
        img:Deal_38,
        Dealname:"Caribbean",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&destinations=9,10,13,14&sortColumn=cruiselinePriority&sortOrder=asc'
    },
    {
        img:Deal_39,
        Dealname:"Allure of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-allure-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=13233&showPromoCodes=true'
    },
    {
        img:Deal_40,
        Dealname:"Quantum of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-quantum-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=13645&showPromoCodes=true'
    },
    {
        img:Deal_41,
        Dealname:"Adventure of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-adventure-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=71&showPromoCodes=true'
    },
    {
        img:Deal_42,
        Dealname:"Anthem of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-anthem-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=13646&showPromoCodes=true'
    },
    {
        img:Deal_43,
        Dealname:"Brilliance of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-brilliance-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=72&showPromoCodes=true'
    },
    {
        img:Deal_44,
        Dealname:"Enchantment of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-enchantment-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=73&showPromoCodes=true'
    },
    {
        img:Deal_45,
        Dealname:"Explorer of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-explorer-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=74&showPromoCodes=true'
    },
    {
        img:Deal_46,
        Dealname:"Freedom of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-freedom-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=116&showPromoCodes=true'
    },
    {
        img:Deal_47,
        Dealname:"Grandeur of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-grandeur-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=75&showPromoCodes=true'
    },
    {
        img:Deal_48,
        Dealname:"Harmony of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-harmony-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=13716&showPromoCodes=true'
    },
    {
        img:Deal_49,
        Dealname:"Icon of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-icon-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=15128&showPromoCodes=true'
    },
    {
        img:Deal_50,
        Dealname:"Independence of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-independence-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=1116&showPromoCodes=true'
    },
    {
        img:Deal_51,
        Dealname:"Jewel of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-jewel-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=76&showPromoCodes=true'
    },
    {
        img:Deal_52,
        Dealname:"Legend of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-legend-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=15469&showPromoCodes=true'
    },
    {
        img:Deal_53,
        Dealname:"Liberty of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-liberty-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=1093&showPromoCodes=true'
    },
    {
        img:Deal_54,
        Dealname:"Mariner of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-mariner-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=79&showPromoCodes=true'
    },
    {
        img:Deal_55,
        Dealname:"Navigator of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-navigator-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=81&showPromoCodes=true'
    },
    {
        img:Deal_56,
        Dealname:"Odyssey of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-odyssey-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=14698&showPromoCodes=true'
    },
    {
        img:Deal_57,
        Dealname:"Ovation of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-ovation-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=13717&showPromoCodes=true'
    },
    {
        img:Deal_58,
        Dealname:"Radiance of the seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-radiance-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=83&showPromoCodes=true'
    },
    {
        img:Deal_59,
        Dealname:"Rhapsody of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-rhapsody-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=84&showPromoCodes=true'
    },
    {
        img:Deal_60,
        Dealname:"Serenade of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-serenade-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=85&showPromoCodes=true'
    },
    {
        img:Deal_61,
        Dealname:"Spectrum of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-spectrum-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=14118&showPromoCodes=true'
    },
    {
        img:Deal_62,
        Dealname:"Star of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-star-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=15330&showPromoCodes=true'
    },
    {
        img:Deal_63,
        Dealname:"Symphony of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-symphony-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=13825&showPromoCodes=true'
    },
    {
        img:Deal_64,
        Dealname:"Utopia of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-utopia-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=15215&showPromoCodes=true'
    },
    {
        img:Deal_80,
        Dealname:"Vision of the Seas",
        link:' https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-vision-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=88&showPromoCodes=true'
    },
    {
        img:Deal_81,
        Dealname:"Voyager of the Seas",
        link:'https://booking.tirun.com/swift/cruise/ship/royal-caribbean-international-voyager-of-the-seas?siid=1035987&lang=1&CruiseLine=8&ship=89&showPromoCodes=true'
    },
    {
        img:Deal_65,
        Dealname:"Silver Muse",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-muse?siid=1035987&lang=1&CruiseLine=8115&ship=13761&showPromoCodes=true'
    },
    {
        img:Deal_66,
        Dealname:"Silver Dawn",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-dawn?siid=1035987&lang=1&CruiseLine=8115&ship=14717&showPromoCodes=true'
    },
    {
        img:Deal_67,
        Dealname:"Silver Moon",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-moon?siid=1035987&lang=1&CruiseLine=8115&ship=14328&showPromoCodes=true'
    },
    {
        img:Deal_68,
        Dealname:"Silver Nova",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-nova?siid=1035987&lang=1&CruiseLine=8115&ship=15112&showPromoCodes=true'
    },
    {
        img:Deal_69,
        Dealname:"Silver Ray",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-ray?siid=1035987&lang=1&CruiseLine=8115&ship=15219&showPromoCodes=true'
    },
    {
        img:Deal_70,
        Dealname:"Silver Shadow",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-shadow?siid=1035987&lang=1&CruiseLine=8115&ship=13287&showPromoCodes=true'
    },
    {
        img:Deal_71,
        Dealname:"Silver Spirit",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-spirit?siid=1035987&lang=1&CruiseLine=8115&ship=13289&showPromoCodes=true'
    },
    {
        img:Deal_72,
        Dealname:"Silver Whisper",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-whisper?siid=1035987&lang=1&CruiseLine=8115&ship=13288&showPromoCodes=true'
    },
    {
        img:Deal_73,
        Dealname:"Silver Cloud",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-cloud-expedition?siid=1035987&lang=1&CruiseLine=8115&ship=13758&showPromoCodes=true'
    },
    {
        img:Deal_74,
        Dealname:"Silver Endeavour",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-endeavour?siid=1035987&lang=1&CruiseLine=8115&ship=15220&showPromoCodes=true'
    },
    {
        img:Deal_75,
        Dealname:"Silver Origin",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-origin?siid=1035987&lang=1&CruiseLine=8115&ship=14504&showPromoCodes=true'
    },
    {
        img:Deal_76,
        Dealname:"Silver Wind",
        link:'https://booking.tirun.com/swift/cruise/ship/silversea-cruises-silver-wind?siid=1035987&lang=1&CruiseLine=8115&ship=13286&showPromoCodes=true'
    },
    {
        img:Deal_77,
        Dealname:"Alaska Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8115&destinationtype=All&Destinations=1&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_78,
        Dealname:"Asia Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8115&destinationtype=All&Destinations=19,124&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_79,
        Dealname:"Galapagos Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8115&destinationtype=All&Destinations=60&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_82,
        Dealname:"Bahamas Cruise",
        link:' https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&destinations=7&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_83,
        Dealname:"Caribbean Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&destinations=10,13,14,9&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_84,
        Dealname:"Australia and New Zealand Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=29&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_85,
        Dealname:"Asia Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=124,19&sortColumn=departureDate&sortOrder=asc'
    },
    {
        img:Deal_10,
        Dealname:"Antarctica Cruise",
        link:'https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=32&sortColumn=cruiselinePriority&sortOrder=asc'
    }
    
]

export default Dealdata ;


